document.addEventListener('DOMContentLoaded', function () {
    const tabs = document.querySelectorAll('.tabs__nav-item');
    const panes = document.querySelectorAll('.tabs__pane');

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        const target = this.getAttribute('data-tab-target');

        // Remove active classes
        tabs.forEach(function (t) {
          t.classList.remove('tabs__nav-item--active');
        });
        panes.forEach(function (pane) {
          pane.classList.remove('tabs__pane--active');
        });

        // Add active class to the clicked tab and corresponding pane
        this.classList.add('tabs__nav-item--active');
        document.getElementById(target).classList.add('tabs__pane--active');
      });
    });
  });